import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { COLORS, FONT } from "../theme";
import Icon from "../components/ui/Icon";

const NAV_ITEMS = [
  { to: "/admin/clientes", label: "Clientes", icon: "briefcase" },
  { to: "/admin/usuarios", label: "Usuários", icon: "users" },
  { to: "/admin/backup", label: "Backup", icon: "backup" },
  { to: "/admin/meus-dados", label: "Meus Dados", icon: "user" },
];

function navStyle({ isActive }) {
  return {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 14px",
    borderRadius: 10,
    fontSize: 13.5,
    fontWeight: isActive ? 600 : 500,
    textDecoration: "none",
    color: isActive ? COLORS.white : COLORS.sidebarText,
    background: isActive ? COLORS.sidebarActiveBg : "transparent",
    letterSpacing: "0.01em",
    transition: "background .15s, color .15s",
  };
}

export default function AdminLayout() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div style={{ display: "flex", height: "100dvh", fontFamily: FONT, background: COLORS.bg }}>
      <aside
        style={{
          width: 250,
          flexShrink: 0,
          background: COLORS.sidebarBg,
          display: "flex",
          flexDirection: "column",
          padding: "28px 16px",
        }}
      >
        <div style={{ padding: "0 0 32px", display: "flex", justifyContent: "center" }}>
          <img src={`${process.env.PUBLIC_URL}/logo-pontozipar.png`} alt="PontoZipar" style={{ height: 88, objectFit: "contain" }} />
        </div>

        <nav style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} style={navStyle}>
              <Icon name={item.icon} size={17} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div style={{ flex: 1 }} />

        <div style={{ padding: "12px 8px", borderTop: `1px solid ${COLORS.sidebarBorder}` }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: COLORS.white }}>{usuario?.nome}</div>
          <div style={{ fontSize: 11.5, color: COLORS.sidebarTextLight, marginBottom: 10, textTransform: "capitalize" }}>{usuario?.perfil}</div>
          <button
            onClick={handleLogout}
            style={{
              width: "100%",
              background: "transparent",
              border: `1.5px solid ${COLORS.sidebarBorder}`,
              borderRadius: 8,
              padding: "8px 12px",
              fontSize: 13,
              fontWeight: 600,
              color: COLORS.sidebarText,
              cursor: "pointer",
            }}
          >
            Sair
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, overflow: "auto", padding: 32 }}>
        <Outlet />
      </main>
    </div>
  );
}
